module.exports = __webpack_public_path__ + "static/media/CABAIRAWIT.c5e94cba.jpeg";